import CompanyLocationFilter from '@/app/[lng]/(home)/search/(Filters)/CommonFilters/CompanyLocationFilter'
import {
  addOrRemoveRetailNewsFilterContinents,
  addOrRemoveRetailNewsFilterCountry,
  addOrRemoveRetailNEwsFilterSubDivision,
  setRetailNewsFilerLanguages,
  setRetailNewsFilterCountry,
} from '@/app/globalRedux/filter/retail/retailnewsFilter'
import { RootState } from '@/app/globalRedux/store'
import { LanguageType } from '@/app/types/constantDataType'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ClearAllRetailFilters from '../../../(components)/ClearAllRetailFilters'
import LanguageFilter from '../../../companies/[[...companyPageNo]]/(components)/LanguageFilter'
import SubDivisionFilter from '../../../companies/[[...companyPageNo]]/(components)/SubDivisionFilter'
import { usePageNumberUpdator } from '@/app/hooks/usePageParamUpdater'

const RetailNewsPageFilter = () => {
  const dispatch = useDispatch()

  const retailNewsFilter = useSelector(
    (state: RootState) => state.retailNewsFilter
  )
  const goToPage = usePageNumberUpdator()
  const [companyLocation, setCompanyLocationText] = useState<string>('')

  return (
    <div
      className=" flex flex-col gap-5 w-[299px] mobile:w-[360px] min-w-[300px]"
      suppressHydrationWarning
    >
      <ClearAllRetailFilters />
      <CompanyLocationFilter
        searchTitle={'Company Location'}
        locationText={companyLocation}
        setLocationText={setCompanyLocationText}
        continentSelectedList={retailNewsFilter?.retailNewsFilterContienent}
        countrySelectedList={retailNewsFilter?.retailNewsFilterCountry}
        setWholeLocation={setRetailNewsFilterCountry}
        addOrRemoveSelectedCountryList={addOrRemoveRetailNewsFilterCountry}
        addOrRemoveSelectedContinentList={addOrRemoveRetailNewsFilterContinents}
      />{' '}
      {/* <CriteriaFilter
        values={retailNewsFilter?.retailNewsCriterias}
        setvalue={(value) => {
          dispatch(addOrRemoveRetailNewsFilterCriteria(value))
        }}
      /> */}
      <SubDivisionFilter
        values={retailNewsFilter?.retailNewsFilterSubDivision}
        setvalue={(value) => {
          dispatch(addOrRemoveRetailNEwsFilterSubDivision(value))
        }}
      />
      <LanguageFilter
        value={retailNewsFilter?.retailNewsFilterLanguages}
        setValue={(value: LanguageType) => {
          dispatch(setRetailNewsFilerLanguages(value))
          goToPage({
            newPageNo: 1,
            searchParam: 'newslng',
            searchValue: value,
          })
        }}
      />
      <div>
        <div></div>
      </div>
    </div>
  )
}

export default RetailNewsPageFilter
